<div class="modal-content">
  <div class="div-message-box animated fadeIn fast ng-scope">
    <div class="message-box-container animated fadeIn fast">
      
      <div class="message-box-middle">
        
        <!-- Loading Spinner -->
        @if (loading) {
<div class="loading-section">
          <i class="fa fa-spinner fa-spin"></i>
          <span class="loading-text">Processing...</span>
        </div>
}

        <!-- Confirmation Content -->
        @if (!loading) {
<div>
          <span class="msg-title ng-binding">
            <i class="fa fa-sign-out txt-color-orangeDark"></i>{{ title }}
          </span>
          <p class="p-text ng-binding">Are you sure you want to refresh the Data?</p>
          
          <div class="message-box-button-section">
            <button 
              class="btn btn-default btn-xs" 
              id="switch-no" 
              (click)="cancel()"
              [disabled]="processing"> 
              No
            </button>
            <button 
              class="btn btn-danger btn-xs" 
              id="switch-yes" 
              (click)="refreshData()"
              [disabled]="processing"> 
              Yes
              @if (processing) {
<span>
                <i class="fa fa-spinner fa-pulse"></i>
              </span>
}
            </button>
            
          </div>
        </div>
}
      </div>
    </div>
  </div>
</div>